import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function SidebarFeature() {
  const [item, setItem] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/media/sidebar_feature").then(r => setItem((r.data || [])[0] || null)).catch(()=>{});
  }, []);
  if (!item) return null;
  const open = () => {
    if (item.link?.startsWith("/")) navigate(item.link);
    else if (item.link) window.open(item.link, "_blank");
  };
  return (
    <div className="lt-sidebar-feature" data-testid="sidebar-feature" onClick={open}
         style={{backgroundImage:`url("${item.image_url}")`}}>
      <div className="lt-sidebar-feature-shade" />
      <div className="lt-sidebar-feature-content">
        <div className="lt-sidebar-feature-tag">{item.title || "FEATURED"}</div>
        <div className="lt-sidebar-feature-title">{item.subtitle || ""}</div>
        <div className="lt-sidebar-feature-arrow">Open →</div>
      </div>
    </div>
  );
}
